import { OidcConfiguration, TokenRenewMode } from '@axa-fr/oidc-client';

export const oidcConfiguration : OidcConfiguration = {
  /* istanbul ignore next -- @preserve */
  authority: process.env.REACT_APP_IDP_URI!,
  client_id: 'piev2client',
  extras: {
    acr_values: process.env.REACT_APP_MOCK_IDP == "true" ? "eherkenning_stub" : 'eherkenning_eh3'
  },
  redirect_uri: `${document.location.origin}/oauth/handler`,
  scope: 'openid token_v2 roaming_profile',
  service_worker_only: true,
  service_worker_relative_url: '/OidcServiceWorker.js',
  silent_redirect_uri: `${window.location.origin}/oauth/silent-callback`,
  token_renew_mode: TokenRenewMode.access_token_invalid
}
